<script setup lang="ts">
const slots = useSlots();

const props = withDefaults(
  defineProps<{
    level?: "h2" | "h3";
    type?: "normal" | "decorative" | "mixed";
    normal?: string;
    decorative?: string;
  }>(),
  {
    level: "h2",
    type: "mixed",
  }
);

const showNormal = computed(
  () =>
    (props.type === "normal" || props.type === "mixed") &&
    (props.normal || slots.normal)
);

const showDecorative = computed(
  () =>
    (props.type === "decorative" || props.type === "mixed") &&
    (props.decorative || slots.decorative)
);

const sizeClass = computed(() => {
  switch (props.level) {
    case "h3":
      return "text-[1.5rem] leading-[2.5rem]";
    default:
    case "h2":
      return "text-[1.75rem] leading-[2.5rem] lg:text-[2.5rem] lg:leading-[2.5rem]";
  }
});
</script>

<template>
  <component :is="level" :class="['content-title', 'px-5 lg:px-0', sizeClass]">
    <span v-if="showNormal" class="inline">
      <slot name="normal" v-bind="{ props }">
        {{ normal }}
      </slot>
    </span>
    <span v-if="showNormal && showDecorative" class="tracking-[0.25rem]"
      >&emsp14;</span
    >
    <span
      v-if="showDecorative"
      class="inline font-display tracking-[0.3125rem]"
    >
      <slot name="decorative" v-bind="{ props }">
        {{ decorative }}
      </slot>
    </span>
  </component>
</template>
